<template>
  <div class="eventComp_mode_2 eventComp_mode_container" v-show="currThemeObj">
    <template v-if="tableData && tableData.length > 0">
      <span
        class="half_table_group"
        v-for="(group, gIndex) in tableData"
        :key="gIndex"
      >
        <span class="table_title" v-text="groupTitleArr[gIndex]"></span>
        <span class="table_main">
          <span class="table_head_gruop" v-text="groupText"></span>
          <span class="customTable">
            <span class="customTable_row">
              <span
                class="customTable_row_cell"
                v-for="headRow in group.table_head"
                :key="headRow.map_key_arr[0]"
                v-text="headRow.name"
              ></span>
            </span>
            <span
              class="customTable_row"
              v-for="(datas, dataIndex) in group.data"
              :key="dataIndex"
            >
              <span
                class="customTable_row_cell"
                v-for="headRow in group.table_head"
                :key="headRow.map_key_arr[0]"
                v-text="datas[headRow.map_key_arr[0]]"
              ></span>
            </span>
          </span>
        </span>
      </span>
    </template>
  </div>
</template>

<script>
// 适用： 射箭对抗类
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'eventComp_mode_2',

  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    datas: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [cup_base_data_mixin],
  watch: {
    datas: {
      handler(newVal, oldVal) {
        console.debug('mode_2 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.init()
        }
      },
      //   immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      tableData: null,
      tableTotal: 0,
      groupTitleArr: ['上半场', '下半场'],
      groupTextArr: ['环数'],
    }
  },

  mounted() {
    this.init()
  },
  computed: {
    groupText() {
      let text = ''
      if (this.currSportsDetail) {
        if (this.currSportsDetail.sportsId === 'ARC') {
          text = this.groupTextArr[0]
        }
      }
      return text
    },
  },
  methods: {
    async init() {
      this.$nextTick(() => {
        this.computedModeData(JSON.parse(JSON.stringify(this.datas)))
      })
    },
    notDataHandler() {
      this.tableTotal = 0
      this.tableData = []
    },
    computedModeData(data) {
      console.debug('computedModeData:', data)
      let tableData = []
      if (data.home && data.home.length > 0) {
        tableData.push(data.home[0].row_detail)
      } else {
        tableData.push({
          data: [],
          table_head: [],
        })
      }
      if (data.away && data.away.length > 0) {
        tableData.push(data.away[0].row_detail)
      } else {
        tableData.push({
          data: [],
          table_head: [],
        })
      }
      if (tableData.length > 0) {
        this.tableData = tableData
      } else {
        this.notDataHandler()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.eventComp_mode_container {
  padding: 1.388vw 0;
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .half_table_group {
    width: calc(50% - 0.694vw);
    height: auto;
    background-color: var(--mixtmt_greyColor8);
    .table_title {
      display: block;
      padding-left: 2.083vw;
      font-size: 0.972vw;
      font-weight: bold;
      color: var(--mixtmt_table_headerColor);
      width: 100%;
      height: 3.125vw;
      line-height: 3.125vw;
      background-color: var(--mixtmt_table_headerBg);
    }
    .table_main {
      width: 100%;
      height: auto;
      color: var(--mixtmt_greyColor3);
      .table_head_gruop {
        display: block;
        font-size: 0.972vw;
        height: 3.125vw;
        text-align: center;
        line-height: 3.125vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
      }
      .customTable {
        width: 100%;
        height: auto;
        display: table;
      }

      .customTable_row {
        display: table-row;
        height: 3.125vw;
        &:first-child {
          .customTable_row_cell {
            border-bottom: 1px solid var(--mixtmt_greyColor7);
          }
        }
      }

      .customTable_row_cell {
        display: table-cell;
        font-size: 0.833vw;
        line-height: 3.125vw;
        color: var(--mixtmt_greyColor3);
        font-weight: bold;
        text-align: center;
        width: 5%;
        vertical-align: middle;
      }
    }
  }
}
</style>
